import React from 'react'
import { SharedControlProps } from '../../models/Common'
import DOMPurify from 'dompurify'

const CalloutDisplay = (props: SharedControlProps) => {
  const sanitizeContent = (data: string) => ({
    __html: DOMPurify.sanitize(data),
  })

  return (
    <div
      className={props.className}
      dangerouslySetInnerHTML={sanitizeContent(props.content)}
    ></div>
  )
}
export default CalloutDisplay
